/**
 * alias 处理
 */

export function getOldParamAlias(param) {
    if (param.type && param.type === 'image') {
        // 大图分享之前版本不支持不做任何处理
    } else {
        param.share_title = param.title;
        param.share_content = param.content;
        param.share_url = param.url;
        param.share_icon_url = param.icon;
    }

    return param;
}
export function alias(name, param, conf, allConf) {
    if (name.indexOf('share') === 0) {
        name = conf.alias ? conf.alias : conf.fn;
        param = getOldParamAlias(param);
    } else if (name === 'setTitle') {
        name = conf.alias ? conf.alias : conf.fn;
        param.navi_title = param.title;
    } else {
        conf ? name = conf.alias ? conf.alias : conf.fn : name;
    }
    return {
        name: name,
        param: param
    };
}



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/global-api/alias.js